export default __webpack_public_path__ + "static/media/bg-7.7b762386.jpg";